import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  imageClassName?: string;
  href?: string;
}

export function Logo({ className, imageClassName, href = '/' }: LogoProps) {
  return (
    <a href={href} className={cn('inline-block group', className)}>
      <img
        src="/logo.png"
        alt="Purple Venture Studio - Designing fundable ventures"
        className={cn(
          'transition-transform duration-300 group-hover:scale-105',
          imageClassName
        )}
      />
    </a>
  );
}
